import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ab86516"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "heading-xl heading" }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = {
  key: 1,
  class: "custom-sign-up-wrapper"
}
const _hoisted_4 = { for: "group" }
const _hoisted_5 = { class: "label-text" }
const _hoisted_6 = { class: "custom-sign-up-tooltip-wrap" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { value: "" }
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  key: 1,
  class: "access-code-wrapper"
}
const _hoisted_11 = { for: "accessCode" }
const _hoisted_12 = { class: "label-text" }
const _hoisted_13 = { class: "custom-sign-up-tooltip-wrap" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { value: "" }
const _hoisted_16 = ["value"]
const _hoisted_17 = {
  key: 1,
  class: "custom-sign-up-text"
}
const _hoisted_18 = { class: "actions" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "spacer" }, null, -1))
const _hoisted_20 = { class: "row-existing-user" }
const _hoisted_21 = { class: "heading-xl text-center" }
const _hoisted_22 = {
  class: "text-center",
  "data-cy": "redirect-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_Tooltip = _resolveComponent("Tooltip")!
  const _component_BaseInputCheckbox = _resolveComponent("BaseInputCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_MHForm = _resolveComponent("MHForm")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, {
    verticalCenter: true,
    size: "xs"
  }, {
    default: _withCtx(() => [
      (_ctx.showForm)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t('heading')), 1),
            _createVNode(_component_MHForm, { ref: "form" }, {
              default: _withCtx(({ meta, handleSubmit }) => [
                _createElementVNode("form", {
                  onSubmit: _withModifiers(($event: any) => (handleSubmit($event, _ctx.signUpUser)), ["prevent"])
                }, [
                  (!_ctx.customSignUpShown)
                    ? (_openBlock(), _createBlock(_component_BaseInputText, {
                        key: 0,
                        "data-cy": "access-code-input",
                        ref: "accessCodeInput",
                        labelLocation: "top",
                        validationRules: "required",
                        validateMode: "passive",
                        inputName: "accessCode",
                        labelText: _ctx.$t('form.accessCodeField.label'),
                        labelSubText: _ctx.$t('form.accessCodeField.info'),
                        inputNiceName: _ctx.$t('form.accessCodeField.name'),
                        inputModel: _ctx.input,
                        "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.input = $event))
                      }, null, 8, ["labelText", "labelSubText", "inputNiceName", "inputModel"]))
                    : _createCommentVNode("", true),
                  (_ctx.customSignUpShown)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_ctx.showGroup)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createElementVNode("label", _hoisted_4, [
                                _createElementVNode("span", _hoisted_5, [
                                  (_ctx.groupField.label)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.groupField.label), 1)
                                      ], 64))
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('form.accessCodeField.label')), 1)
                                      ], 64))
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_Tooltip, { class: "custom-sign-up-tooltip" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "content",
                                        innerHTML: _ctx.groupField.helpTooltip
                                      }, null, 8, _hoisted_7)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _withDirectives(_createElementVNode("select", {
                                id: "group",
                                name: "group",
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.customSignUpGroup) = $event))
                              }, [
                                _createElementVNode("option", _hoisted_8, _toDisplayString(_ctx.$t('customSignUpField.selectOptionGroupDefault')), 1),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupField.choices, (choice) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    key: choice.value,
                                    value: choice.value
                                  }, _toDisplayString(choice.label), 9, _hoisted_9))
                                }), 128))
                              ], 512), [
                                [_vModelSelect, _ctx.customSignUpGroup]
                              ])
                            ], 64))
                          : _createCommentVNode("", true),
                        ((_ctx.showGroup && _ctx.customSignUpGroup.length > 0) || !_ctx.showGroup)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                              _createElementVNode("label", _hoisted_11, [
                                _createElementVNode("span", _hoisted_12, [
                                  (_ctx.accessCodeField.label)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(_toDisplayString(_ctx.accessCodeField.label), 1)
                                      ], 64))
                                    : (!_ctx.accessCodeField.label)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createTextVNode(_toDisplayString(_ctx.$t('form.accessCodeField.label')), 1)
                                        ], 64))
                                      : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_Tooltip, { class: "custom-sign-up-tooltip" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "content",
                                        innerHTML: _ctx.accessCodeField.helpTooltip
                                      }, null, 8, _hoisted_14)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              (_ctx.accessCodeField.type === 'DROP_DOWN')
                                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                                    key: 0,
                                    id: "accessCode",
                                    name: "accessCode",
                                    ref: "accessCodeInput",
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.input) = $event))
                                  }, [
                                    _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.$t('customSignUpField.selectOptionAccessCodeDefault')), 1),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.providerFilteredAccessCodes, (choice) => {
                                      return (_openBlock(), _createElementBlock("option", {
                                        key: choice.value,
                                        value: choice.value
                                      }, _toDisplayString(choice.label), 9, _hoisted_16))
                                    }), 128))
                                  ], 512)), [
                                    [_vModelSelect, _ctx.input]
                                  ])
                                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    _createVNode(_component_BaseInputText, {
                                      labelLocation: "top",
                                      "data-cy": "access-code-input",
                                      validationRules: "required",
                                      ref: "accessCodeInput",
                                      validateMode: "passive",
                                      inputName: "accessCode",
                                      inputModel: _ctx.input,
                                      "onUpdate:inputModel": _cache[3] || (_cache[3] = ($event: any) => (_ctx.input = $event))
                                    }, null, 8, ["inputModel"])
                                  ]))
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_BaseInputCheckbox, {
                    "data-cy": "location-checkbox",
                    inputName: _ctx.$t('form.locationCheckbox.name'),
                    labelText: _ctx.$t('form.locationCheckbox.label'),
                    inputModel: _ctx.isSubjectToGdpr,
                    "onUpdate:inputModel": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSubjectToGdpr = $event))
                  }, null, 8, ["inputName", "labelText", "inputModel"]),
                  _createElementVNode("div", _hoisted_18, [
                    _createVNode(_component_BaseButton, {
                      class: "btn-primary",
                      type: "submit",
                      "data-cy": "next-button",
                      "aria-disabled": !_ctx.isAccessCodeValid || !meta.valid
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('form.nextBtn')), 1)
                      ]),
                      _: 2
                    }, 1032, ["aria-disabled"])
                  ]),
                  _hoisted_19,
                  _createElementVNode("div", _hoisted_20, [
                    _createTextVNode(_toDisplayString(_ctx.$t('existingUser.isUser')) + " ", 1),
                    _createVNode(_component_router_link, {
                      class: "link-forgot-password",
                      to: {"name":"Login"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('existingUser.signInLink')), 1)
                      ]),
                      _: 1
                    })
                  ])
                ], 40, _hoisted_2)
              ]),
              _: 1
            }, 512)
          ], 64))
        : _createCommentVNode("", true),
      (!_ctx.showForm)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h1", _hoisted_21, _toDisplayString(_ctx.$t(_ctx.regDestination === 'Teladoc' ? 'heading2.Teladoc' : 'heading2.default')), 1),
            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t(`text.${_ctx.regDestination}`)), 1)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}